import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index.js'
import { Message } from 'element-ui';
Vue.prototype.$message = Message;
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
	//页面置顶
	scrollBehavior(to,from,saveTop){
		if(saveTop){
			return saveTop
		}else{
			return {x:0,y:0}
		}
	},
  routes: [
   //路由懒加载，优化性能
   // {
   //   path:"*",
   //   redirect:'/norights'
   // },
   {
   	 path: '/',
     redirect:'/home',//默认显示首页的二级路由
     component:() => import('@/view/Index'),
     children:
     [
   	 { path:'/home',
       name:'home',
   	   component:() => import('@/view/Home/home'),
       meta: {
             keepAlive: false // 需要被缓存
           }
   	 },
		 { path:'/fclbysea',
		   name:'fclbysea',
		   component:() => import('@/view/PriceQuery/fclBySea'),
			 meta: {
			       keepAlive: false // 需要被缓存
			     }
		 },
		 { path:'/lclbysea',
		   name:'lclbysea',
		   component:() => import('@/view/PriceQuery/lclBySea'),
		   meta: {
		         keepAlive: false // 需要被缓存
		       }
		 },
		 { path:'/byair',
		   name:'byair',
		   component:() => import('@/view/PriceQuery/ByAir'),
		   meta: {
		         keepAlive: false // 需要被缓存
		       }
		 },
		 { path:'/railroad',
		   name:'railroad',
		   component:() => import('@/view/PriceQuery/railRoad'),
		   meta: {
		         keepAlive: false // 需要被缓存
		       }
		 },
		 { path:'/trailer',
		   name:'trailer',
		   component:() => import('@/view/PriceQuery/Trailer'),
		   meta: {
		         keepAlive: false // 需要被缓存
		       }
		 },
		 { path:'/express',
		   name:'express',
		   component:() => import('@/view/PriceQuery/Express'),
		   meta: {
		         keepAlive: false // 需要被缓存
		       }
		 },
     { path:'/userAllInfo',
       component:() => import('@/view/UserInfo/userAllInfo')
     },
     { path:'/userInfo',
       component:() => import('@/view/UserInfo/userInfo')
     },
     { path:'/userAvatar',
       component:() => import('@/view/UserInfo/userAvatar')
     },
     { path:'/userPwd',
       component:() => import('@/view/UserInfo/userPwd')
     },
     { path:'/us',
       name:'us',
       component:() => import('@/view/Us'),
       meta: {
             keepAlive: false // 需要被缓存
           }
     },
     { path:'/contact',
       name:'contact',
       component:() => import('@/view/Contact'),
       meta: {
             keepAlive: false // 需要被缓存
           }
     },
		 { path:'/entrustment',
		   name:'entrustment',
		   component:() => import('@/view/Entrustment'),
		   meta: {
		         keepAlive: false // 需要被缓存
		       }
		 },
     
     ]
   },
   { path: '/login', component:() => import('@/view/Login')},
   //{ path: '/register', component:() => import('@/view/Register')},
   { path:'/norights',component:() => import('@/view/Norights')},
   { path:'/freeze',component:() => import('@/view/Freeze')},
   { path:'/tips',component:() => import('@/view/Tips')},
  ]
})




// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  //     next()  放行    next('/login')  强制跳转

let status_user =store.getters.statesw
// console.log(status_user)
  //if (to.path === '/login' || to.path === '/freeze'  || to.path === '/norights') return next()
 //获取状态
    if (status_user ==2) {
     return next('/freeze')
	 }
	  // 获取token
  // const tokenStr = window.sessionStorage.getItem('token')
  //  if (!tokenStr) return next('/login')
  //没有登录进行判断
  if (to.path=='/entrustment' || to.path=='/userAllInfo' || to.path=='/userInfo' || to.path=='/userAvatar' || to.path=='/userPwd') {
     const tokenStr = window.sessionStorage.getItem('token')
      if(tokenStr) {
        next()
      } else {
        next('/home')
      }
    } else {
      next()
    }
 
  

  next()
})



//每次路由跳转，返回页面最顶部
// router.afterEach((to,from,next)=>{
//  // Vue.prototype.$message.close() // 官网指定方法
//  // console.log(111)
// })

export default router
